// extracted by mini-css-extract-plugin
export default {"customization-not-available":"not-available_customization-not-available__RUULG","customization-not-available__desc":"not-available_customization-not-available__desc__7yekS"};